import { ReactNode } from 'react';
import { PaperAirplaneIcon } from '@heroicons/react/solid';

import { EntityHistory } from '../entity-history';
import { DatabaseUser, HistoryItem } from '@/core/types';

export default class ShareLinkDeleteHistory extends EntityHistory {
  constructor(history: HistoryItem, user: DatabaseUser) {
    super(history, user);
    this.action = 'cancelled';
  }

  entityType(): string {
    if (this.history.attributes?.prev.folder) {
      return 'folder';
    } else {
      return 'file';
    }
  }

  entityName(): string {
    if (this.history.attributes?.prev.folder) {
      return this.history.attributes?.prev.folder.name;
    } else {
      return this.history.attributes?.prev.file.name;
    }
  }

  detailText(): ReactNode {
    return (
      <div data-testid="history-detail-text">
        The invite to{' '}
        <span className="font-semibold break-all">{this.history.attributes?.next.email}</span> was{' '}
        {this.action} for the {this.entityType()}{' '}
        <span className="font-semibold break-all">{this.entityName()}.</span>
      </div>
    );
  }

  displayText(): ReactNode {
    return (
      <>
        <b>{this.userName}</b> {this.action} an invite to this {this.entityType()}
      </>
    );
  }

  detailIcon(): ReactNode {
    return <PaperAirplaneIcon className="-rotate-90 fill-support-error h-5" />;
  }
}
